module.exports = __webpack_public_path__ + "img/apple-store.8de1142.svg";